<template>
  <div class="page">
    <mobileHeader :title="`钢瓶${stateObj[state].title}`" rightType="scanCode"></mobileHeader>
    <div class="center">
      <GasCylinderInfo v-if="!isMultiple" :bottleInfo="bottleInfoCache"/>
      <bottleList v-else />
      <div class="state-title">
        <img :src="stateObj[state].img" alt="" />
        <div>{{ stateObj[state].title }}</div>
      </div>
      <van-form class="form-list" @submit="submit">
        <div class="input-item">
          <van-field
            v-model="post.address"
            type="text"
            placeholder="自动获取位置中..."
            disabled
            @click="getLocation"
            :rules="[{ required: true, message: '点击重新获取位置' }]"
          />
          <img src="@/assets/images/dingwei_1.png" alt="" />
        </div>
        <div class="input-item" v-if="state != 6 && state != 7 && state != 8">
          <van-field
            v-model="post.value1"
            type="text"
            :placeholder="stateObj[state].placeholder"
            disabled
            :rules="stateObj[state].rules1"
          />
          <img src="@/assets/images/Shapecopy.png" alt="" />
        </div>
        <template v-if="state != 1 && state != 5">

          <div class="input-item" v-if="state != 2 && state != 3">
            <van-field
              v-model="post.value2"
              type="text"
              :placeholder="stateObj[state].placeholder2"
              :rules="stateObj[state].rules2"
            />
            <img src="@/assets/images/xiugai.png" alt="" />
          </div>
        </template>
        <div class="input-item" v-else>
            <van-field
              v-model="post.value2"
              type="number"
              @input="numberInput"
              :placeholder="stateObj[state].placeholder2"
              :rules="stateObj[state].rules2"
            />
            <img src="@/assets/images/xiugai.png" alt="" />
          </div>

        <div class="submit">
          <van-button block type="primary" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import GasCylinderInfo from "@/components/GasCylinderInfo";
import bottleList from "@/components/bottleList";
import { bottleFillingAdd, bottleDeliveryAdd, bottleGasAdd, bottleUseAdd, bottleRecyclingAdd, bottleDetectionAdd, bottleScrapAdd, bottleOtherAdd } from "@/api/flowPath";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      stateObj: {
        1: {
          title: "充装",
          img: require("@/assets/images/ranqichupei.png"),
          placeholder: "自动获取充装站扫码人员姓名",
          placeholder2: "请输入充装前余气实测重量",
          rules1: [{ required: true, message: "充气员不能为空" }],
          rules2: [{ required: true, message: "请输入充装前余气实测重量" }, {validator: (val) => {
            if(val <= 15 && val >= 0)return true
            return false
          }, message: "请输入大于等于0小于等于15的数值"}],
        },
        2: {
          title: "配送",
          img: require("@/assets/images/ranqiqiye.png"),
          placeholder: "自动获取配送站点",
        },
        3: {
          title: "送气",
          img: require("@/assets/images/cheliangjianguan.png"),
          placeholder: "自动获取配送员姓名",
        },
        4: {
          title: "使用",
          img: require("@/assets/images/ranqibiao_shiti.png"),
          placeholder: "自动获取钢瓶客户的姓名",
          placeholder2: "编辑店铺名称",
          // rules2: [{ required: true, message: "店铺名称不能为空" }],
        },
        5: {
          title: "回收",
          img: require("@/assets/images/huishouzhan.png"),
          placeholder: "自动获取扫码人员姓名",
          placeholder2: "请输入当前轻瓶内余气实测重量",
          rules2: [{ required: true, message: "轻瓶内余气实测重量不能为空" }, {validator: (val) => {
            if(val <= 15 && val >= 0)return true
            return false
          }, message: "请输入大于等于0小于等于15的数值"}],
        },
        6: {
          title: "检测",
          img: require("@/assets/images/manage-circuit-full.png"),
          placeholder2: "请输入检测单位名称",
          rules2: [{ required: true, message: "检测单位名称不能为空" }],
        },
        7: {
          title: "报废",
          img: require("@/assets/images/jijubaofeishenqing.png"),
          placeholder2: "请输入报废单位名称",
          rules2: [{ required: true, message: "报废单位名称不能为空" }],
        },
        8: {
          title: "其他",
          img: require("@/assets/images/guanli.png"),
          placeholder2: "请输入其他说明",
          rules2: [{ required: true, message: "其他说明不能为空" }],
        },
      },
      state: null,
      location: null,
      post: {
        address: "",
        value1: "",
        value2: "",
      },
      isMultiple: false
    };
  },
  components: {
    mobileHeader,
    GasCylinderInfo,
    bottleList
  },
  async created() {
    this.isMultiple = !!this.$route.query.isMultiple
    // console.log(this.$store.state.location, 'locationlocation')
    const { state } = this.$route.query;
    console.log(state,"state")
    this.state = state;
    this.getInfo(state);
    this.getLocation();
    if(this.address) {(this.post.address = this.address);return true}
    const time = setInterval(_=>{
      this.address && (this.post.address = this.address, clearInterval(time))
    }, 2000)
  },
  computed: {
    bottleInfo() {
      return this.$store.state.bottleInfo;
    },
    bottleInfoCache(){
      return this.$store.state.bottleInfoCache;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    bottleId(){
      return this.$store.state.bottleId
    },
    address(){
      return this.$store.state.location.address
    }
  },
  watch: {
    bottleId: () => {
      this.userRole == 3 && this.getInfo(this.state)
    }
  },
  methods: {
    numberInput(e){
      this.post.value2.indexOf('-') == 0 && (this.post.value2 = '')
    },
    getLocation() {
      this.mixGetLocation((location) => {
        this.post.address = location.address;
      });
    },
    async getInfo(state) {
      switch(state){
        case "1":
          this.post.value1 = this.bottleInfoCache.user_name;
          break;
        case "2":
          this.post.value1 = this.bottleInfoCache.shop_name;
          break;
        case "3":
          this.post.value1 = this.bottleInfoCache.user_name;
          break;
        case "4":
          this.post.value1 = this.bottleInfoCache.using_name;
          break;
        case "5":
          this.post.value1 = this.bottleInfoCache.user_name;
          break;
      }
      console.log(this.post, "this.post");
    },
    async submit() {
      console.log(321321.123);
      // 1充装，2配送站，3送气，4使用，5回收，6检测，7报废，8其它，9安检提交

      Dialog.confirm({
        title: "提示",
        message: "是否确认提交",
        beforeClose: this.beforeCloses,
      });
    },
    async beforeCloses(action, done) {
      // return new Promise(async (resolve) => {
          if (action === "confirm") {
            const bottle_id = this.isMultiple ? this.$route.query.bottleIdList : this.bottleId
            // 充装  bottleFillingAdd
            if (this.state == 1 && (this.userRole == 1 || this.userRole == 3)) {
              const ret = await bottleFillingAdd({
                bottle_id,
                station_check_location: this.post.address,
                station_check_weight: this.post.value2,
              });
              done(true);
              return this.afterCallback(ret,"充装")
            }
            // 配送 bottleDeliveryAdd
            if(this.state == 2 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleDeliveryAdd({
                bottle_id,
                delivery_location: this.post.address,
              });
              done(true);
              return this.afterCallback(ret,"配送")
            }
            // 送气 bottleGasAdd
            if(this.state == 3 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleGasAdd({
                bottle_id,
                gas_location: this.post.address,
              });
              done(true);
              return this.afterCallback(ret,"送气")
            }
            // 使用 bottleUseAdd
            if(this.state == 4 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleUseAdd({
                bottle_id,
                use_location: this.post.address,
                use_shop: this.post.value2
              });
              done(true);
              return this.afterCallback(ret,"使用")
            }
            // 回收 bottleRecyclingAdd
            if(this.state == 5 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleRecyclingAdd({
                bottle_id,
                recycling_location: this.post.address,
                recycling_weight: this.post.value2
              });
              done(true);
              return this.afterCallback(ret,"回收")
            }
            // 检测 bottleDetectionAdd
            if(this.state == 6 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleDetectionAdd({
                bottle_id,
                detection_location: this.post.address,
                detection_unit: this.post.value2
              });
              done(true);
              return this.afterCallback(ret,"检测")
            }
            // 报废 bottleScrapAdd
            if(this.state == 7 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleScrapAdd({
                bottle_id,
                scrap_location: this.post.address,
                scrap_unit: this.post.value2
              });
              done(true);
              return this.afterCallback(ret,"报废")
            }
            // 其他 bottleOtherAdd
            if(this.state == 8 && (this.userRole == 1 || this.userRole == 2)){
              const ret = await bottleOtherAdd({
                bottle_id,
                other_location: this.post.address,
                other_text: this.post.value2
              });
              done(true);
              return this.afterCallback(ret,"其他")
            }
          } else {
            done(true);
          }
        // });
    },
    afterCallback({ code, msg }, text){
      code == 200
        ? (Toast({message: `完成${text}流程`,duration: 500}),
          setTimeout(_ => {
            this.mixGetBottleInfo();
            this.userRole == 3 ? this.$router.push("/flowPath/scanCode") : this.$router.push("/flowPath/index")
          }, 500))
        : Toast({message: msg?msg:'服务端错误',duration: 500});
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page {
  display: flex;
  background: #ffffff;
  height: auto;
  min-height: 100vh;
  width: 100vw;
  flex-direction: column;
  .center {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background: #f7f7f7;
    .state-title {
      text-align: center;
      padding-top: 7.6vw;
      padding-bottom: 5.5vw;
      font-size: 6.7vw;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #34D132;
      width: 100%;
      img {
        width: 19.4vw;
      }
    }
    .form-list {
      flex: 1;
      background: #f7f7f7;
      padding: 0 8vw;
      padding-top: 5vw;
      .input-item {
        width: 84vw;
        height: 14vw;
        background: #ffffff;
        border: 1px solid #bfbfbf;
        border-radius: 1.4vw;
        margin-bottom: 7vw;
        display: flex;
        align-items: center;
        input {
          outline: none;
          border: 0;
          flex: 1;
          padding: 0 4vw;
          background: white;
          font-size: 4.2vw;
        }
        img {
          width: 7.5vw;
          margin-right: 2.3vw;
        }
      }
      .submit {
        margin-top: 15.3vw;
        img {
          width: 83vw;
          height: 100%;
        }
        ::v-deep .van-button {
          width: 83vw;
          height: 14vw;
          border: 0;
          background: #43a3fe;
          font-size: 7vw;
          border-radius: 4px;
        }
      }
    }
  }
  ::v-deep .van-cell::after {
    display: none;
  }
  ::v-deep .van-field__error-message {
    position: absolute;
    z-index: 99;
    margin-top: 4vw;
  }
  ::v-deep .van-cell,
  ::v-deep .van-cell__value {
    overflow: initial;
    font-size: 4.2vw;
  }
  ::v-deep .van-field__control:disabled{
    -webkit-text-fill-color: #323233;
    color: #323233;
  }
}
</style>
